import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import RatingStar from "../../assets/images/rating.png";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { testimonials } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./testimonials.css";

import styles from "./Testimonials.module.css";

const Slider = () => {
  const swiperRef = useRef(null);
  const { response, loading, error } = useApi(API_ENDPOINTS.HOME_TESTIMONIALS);
  const apiData = response?.testimonials ?? testimonials;
  const navigate = useNavigate();
  return loading ? (
    <Loader />
  ) : error ? (
    <ErrorMsg />
  ) : (
    <section className="testimonials-section">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        navigation
        pagination={{
          clickable: true,
          type: "bullets",
        }}
        autoplay={{ delay: 5000 }}
        loop={true}
        breakpoints={{
          0: { slidesPerView: 1 }, // mobile
          768: { slidesPerView: 1 }, // tablet
          1024: { slidesPerView: 2 }, // desktop
        }}
        className="testimonial-swiper"
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        {apiData.map((t, index) => (
          <SwiperSlide key={index}>
            <article className={styles.card}>
              <div className={styles.quotes}>
                <span></span>
              </div>
              <div className={styles.userDetails}>
                <figure>
                  <img src={t.image} alt={t.label} />
                </figure>
                <div className={styles.content}>
                  <h6>{t.label}</h6>
                  <p>{t.designation}</p>
                  <div className={styles.ratingContainer}>
                    <img src={RatingStar} alt="star" />
                    <img src={RatingStar} alt="star" />
                    <img src={RatingStar} alt="star" />
                    <img src={RatingStar} alt="star" />
                    <img src={RatingStar} alt="star" />
                  </div>
                </div>
              </div>
              <p>{t.description}</p>
              <button onClick={() => navigate("/knowledge-series-events")}>
                {t.button_name || "Published via Knowledge Series"}
              </button>
            </article>
          </SwiperSlide>
        ))}
      </Swiper>
      <button
        className="custom-prev"
        onClick={() => swiperRef.current.slidePrev()}
      >
        &nbsp;
      </button>
      <button
        className="custom-next"
        onClick={() => swiperRef.current.slideNext()}
      >
        &nbsp;
      </button>
    </section>
  );
};

export default Slider;
